module.exports = __webpack_public_path__ + "static/media/ic_pencil.f35857e0.png";